import moment from "moment";
import React, { useEffect, useState } from "react";
import { deleteCalls, getCallRecord } from "../../AxiosRtk/CallSms";
import { handleStartDate } from "../../../../utils/helper";
import useLangTranslation from "../../../customHooks/languageProvider";
import useDurationOption from "../../../customHooks/durationOption";
import { handleStartDateCommon } from "../../../../utils/helper";
import Select from "react-select";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import { useDispatch } from "react-redux";

const SmsLog = ({ deviceId, selectedKidId }) => {
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const dispatch = useDispatch();

  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [smsLogs, setSmsLogs] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { getLangTranslation } = useLangTranslation();

  const handleCheckboxClick = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(smsLogs.map((item) => item.ID));
    }
    setSelectAll(!selectAll);
  };
  function getCalls() {
    const obj = {
      startDate: startDate,
      endDate: endDate,
      activityType: "SMS",
      kidId: selectedKidId,
      deviceId: deviceId,
    };
    getCallRecord(obj)
      .then((res) => {
        setSmsLogs(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }
  useEffect(() => {
    if (deviceId) {
      getCalls();
    }
  }, [deviceId, startDate]);

  const handleDelete = async () => {
    let payload;

    if (selectAll) {
      payload = {
        id: 0, // Assuming '0' means delete all
        activityType: "SMS",
        isAlertDelete: 0,
        isDeleteAll: 1, // Indicating that we want to delete all
        deviceId: deviceId,
      };
    } else {
      let deleteId;

      // If there is only one selected item, convert it to a string
      if (selectedItems.length === 1) {
        deleteId = selectedItems[0].toString();
      } else {
        deleteId = selectedItems;
      }

      payload = {
        id: deleteId, // For multiple selected items
        activityType: "SMS",
        isAlertDelete: 0,
        isDeleteAll: 0, // Indicating it's not a 'delete all' action
        deviceId: deviceId,
      };
    }

    try {
      const { data } = await deleteCalls(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        // closeDeletedSelected();
        setSelectedItems([]);
        setSelectAll(false);


        // Delay the call to getCalls by 12 seconds
        setTimeout(() => {
          // window.location.reload();

          getCalls(); // Fetch the updated SMS logs after 12 seconds
        }, 3000);
      }
    } catch (error) {
      // closeDeletedSelected();
      console.log("Error deleting SMS logs:", error);
    }
    // Call the API to delete the selected SMS logs
    // deleteCalls(payload)
    //   .then((res) => {
    //     if (res?.data?.status) {
    //       // alert("1")
    //       // Clear the selected items and deselect the 'select all' checkbox
    //       setSelectedItems([]);
    //       setSelectAll(false);


    //       // Delay the call to getCalls by 12 seconds
    //       setTimeout(() => {
    //         // window.location.reload();

    //         getCalls(); // Fetch the updated SMS logs after 12 seconds
    //       }, 3000);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Error deleting SMS logs:", err?.response?.data?.message);
    //   });
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
        <div className="d-flex align-items-center flex-wrap gap-6">
          <div className="form-check">
            <input
              className="form-check-input"
              id="enableScreenshot"
              type="checkbox"
              role="switch"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            <label className="form-check-label text-dark" htmlFor="selectAll">
              {getLangTranslation(
                "MANAGE_NOTIFICATION_SELECT_ALL",
                "Select All"
              )}
            </label>
          </div>
          <button
            className="btn btn-outline-primary"
            type="button"
            onClick={handleDelete}
          >
            {getLangTranslation(
              "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
              "Delete selected"
            )}
          </button>
        </div>
        <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
          <DateFilter
            startDate={startDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            selectedDuration={selectedDuration}
          />
          <Select
            className="custom-select"
            classNamePrefix="custom-select"
            placeholder="Select"
            onChange={(val) => {
              handleStartDateCommon(
                val,
                setStartDate,
                setSelectedDuration,
                setEndDate
              );
            }}
            options={durationOptions}
            value={
              durationOptions?.find(
                (item) => item?.value === selectedDuration
              ) || ""
            }
          />
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="v-middle" scope="col">
                <div className="form-check">
                  <label className="form-check-label mt-1" htmlFor="taskName">
                    {getLangTranslation("ADD_CHILD_NAME", "Name")}
                  </label>
                </div>
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("PHONE_NUMBER", "Phone number")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("PARENT_NAV_MESSAGE", "Messages")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("DATE", "Date")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation(
                  "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                  "status"
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {smsLogs?.map((item, index) => (
              <tr key={index}>
                <td className="v-middle">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`checkbox-${item?.ID}`}
                      checked={selectedItems.includes(item?.ID)}
                      onChange={() => handleCheckboxClick(item?.ID)}
                    />
                    <label
                      className="form-check-label text-nowrap"
                      htmlFor="one"
                    >
                      {item?.smsName}
                    </label>
                  </div>
                </td>
                <td className="v-middle text-nowrap">{item?.smsNumber}</td>
                <td className="v-middle">
                  <p className="text-small mb-0">{item?.smsMessage}</p>
                </td>
                <td className="v-middle text-nowrap">
                  {moment(item?.messageDateTime).format("MMM, DD YYYY hh:mm")}
                </td>
                <td className="v-middle text-nowrap">
                  {item?.activityStatus === 1
                    ? getLangTranslation("SMSLOGS_RECEIVED_SMS")
                    : getLangTranslation("SMSLOGS_SENT_SMS", "Sent SMS")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {smsLogs?.length === 0 && (
          <div className="text-center my-2 text-capitalize">
            --{" "}
            {getLangTranslation(
              "PARENT_TASK_DATA_NOT_FOUND",
              "No data found !"
            )}{" "}
            --
          </div>
        )}
      </div>
    </>
  );
};

export default SmsLog;
